export const ERROR_MESSAGES = {
  UNABLE_TO_OPEN_SPACE_DOOR: 'common.unableOpenSpaceDoor',
} as const;
